/**
 * For refreshing the JWT auth token
 *
 * @author David Faber
 * @copyright (c) LX media GmbH
 */
import {gql} from '@apollo/client';

const REFRESH_AUTH_TOKEN = gql`
  mutation refreshJwtAuthToken($input: RefreshJwtAuthTokenInput!) {
    refreshJwtAuthToken(input: $input) {
      authToken
    }
  }
`;
export default REFRESH_AUTH_TOKEN;
